
import { requst } from '../config'

/* 周计划上传图片 */
export const postWeeklyPlanAvatarApi = (file, projectId) => {
    const formData = new FormData()
    formData.append('file', file)
    const url = `/file/upload?projectId=${projectId}`
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}

/* 提交 Weekly 数据 */
export const postWeeklyProductionApi = params => {
    const url = `/setting/productionPlan/save`
    return requst.post(url, params)
}

/* 获取 Weekly 数据 */
export const getWeeklyProductionApi = projectId => {
    const url = `/setting/productionPlan/listAll?projectId=${projectId}`
    return requst.get(url)
}

/* 获取 Weekly 实际 产量 数据 */
export const getWeeklyActualProductionApi = params => {
    const url = `/setting/productionPlan/listOBNActual?projectId=${params.projectId}&startDate=${params.startDate}&endDate=${params.endDate}`
    return requst.get(url)
}